import jwtDecode from 'jwt-decode';

interface IDecodedToken {
    exp: string;
}

export const expirationDateIsInFuture = (exp: string): boolean =>
    Date.now() <= Number(exp) * 1000;

export const tokenIsValid = (token: string): boolean => {
    const { exp }: IDecodedToken = jwtDecode(token);

    return expirationDateIsInFuture(exp);
};
